{
  "version": 1,
  "asset_id": "5e976ffc-5cf6-4b63-9274-b0b5dc35b9a8",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/5e976ffc-5cf6-4b63-9274-b0b5dc35b9a8/ind-real-estate-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/5e976ffc-5cf6-4b63-9274-b0b5dc35b9a8/ind-real-estate-1200.webp",
  "original_filename": "ind-real-estate-1200.webp",
  "size": 14366,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:10Z"
}
